export const isDevEnv: boolean = __BUILD_ENV__ === "DEV";
export const isProdEnv: boolean = __BUILD_ENV__ === "PROD";

export const usingLocalBackend: boolean = isDevEnv && __LOCAL_API__;
export const usingFirebaseBackend: boolean =
  isDevEnv && __FIREBASE_API__ && !usingLocalBackend; // local takes priority over firebase
